import { steps as newReferralSteps } from 'mixins/ReferralsNewPageMixin'
import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'
import RequireSignupFinishedMiddleware from 'middlewares/RequireSignupFinishedMiddleware'
import RequirePhysicianOrAncillaryOrDemoMiddleware from 'middlewares/RequirePhysicianOrAncillaryOrDemoMiddleware'

export default [
    ...[
        { type: 'received', tabType: 'referrals' },
        { type: 'received', tabType: 'pool' },
        { type: 'received', tabType: 'referrals-patient' },
        { type: 'received', tabType: 'pool-patient' },
        { type: 'made', tabType: 'referrals' },
        { type: 'made', tabType: 'pool' },
    ].map(({ type, tabType }) => ({
        path: `/referrals/${type}/${tabType}`,
        name: `referrals.${type}.${tabType}`,
        view: 'referrals/tracking/Index',
        default: { query: { state: 'all', limit: 10 }, params: { type, tabType } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryOrDemoMiddleware, RequireUserMiddleware],
    })),
    ...['received', 'made'].map((type) => ({
        path: `/referrals/${type}/:id`,
        name: `referrals.${type}.show`,
        view: 'referrals/tracking/Show',
        default: { params: { type } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryOrDemoMiddleware, RequireUserMiddleware],
    })),
    ...[
        { type: 'received', action: 'update-slot' },
        { type: 'received', action: 'add-report' },
        { type: 'made', action: 'rate-referred' },
    ].map(({ type, action }) => ({
        path: `/referrals/${type}/:id/${action}`,
        name: `referrals.${type}.${action}`,
        view: 'referrals/tracking/Update',
        default: { params: { type, action } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryOrDemoMiddleware, RequireUserMiddleware],
    })),
    {
        path: '/referrals/eprescribe',
        name: 'referrals.eprescribe',
        view: 'referrals/ePrescribe/Eprescribe',
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryOrDemoMiddleware, RequireUserMiddleware],
    },
    {
        path: '/referrals/new',
        name: 'referrals.new',
        redirect: { name: `referrals.new.${newReferralSteps[0].path}` },
    },
    ...newReferralSteps.map((step) => ({
        path: `/referrals/new/${step.path}`,
        name: `referrals.new.${step.path}`,
        view: `referrals/new/${step.view}`,
        default: { query: { limit: 6 }, params: { step: step.path } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryOrDemoMiddleware, RequireUserMiddleware],
    })),
    ...['received', 'made'].map((type) => ({
        path: `/referrals/${type}/:id/view-report`,
        name: `referrals.${type}.report`,
        view: 'referrals/tracking/ViewReport',
        default: { params: { type } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryOrDemoMiddleware, RequireUserMiddleware],
    })),
    {
        path: '/referrals/ancillary-services-tests',
        name: 'referrals.services.tests',
        view: 'referrals/ancillary/AncillaryServiceTests',
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryOrDemoMiddleware, RequireUserMiddleware],
    },
    {
        path: '/referrals/primary-care/:referralId/:signature',
        name: 'referrals.pc.insurance',
        view: 'referrals/tracking/PrimaryCareInsurance',
    },

    ...['received', 'made'].map((type) => ({
        path: '/referrals/:referralId/propose',
        name: `referrals.${type}.propose`,
        view: 'referrals/tracking/ReferralProposeTime',
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryOrDemoMiddleware, RequireUserMiddleware],
    })),
    {
        path: '/referrals/ancillary-services-tests/outsider',
        name: 'referrals.services.tests.outsider',
        view: 'referrals/ancillary/outsider/AncillaryServiceTests',
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryOrDemoMiddleware, RequireUserMiddleware],
    },
]
